import $ from 'jquery';

export default (props, e) => {
e.preventDefault();
	$(e.target).closest('.header__nav-main').toggleClass('opened');

	var pageHeader = $('.page-header');

var navMain = $(".js_headerNavMain");
var navActions = $(".header__nav-actions");
var navFaculty = $(".header__nav-faculty");
	pageHeader.toggleClass("is-active");

//navMain.toggleClass("opened");
navActions.toggleClass("opened");
navFaculty.toggleClass("opened");
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/menuToggle.js